export default function GS_Format_Grids() {
  return (
    <div className="p-4">
      <h1>GS Format Grids</h1>
    </div>
  );
}
